import { useParams } from "react-router-dom";
import { getAwardImg } from './constants';
import './style.css';
import TermsAndCondition from './TermsAndCondition';
import useDiwaliHook from './useDiwaliHook';
import { getLeaderboardTerms } from "./constants";
import { useEffect, useState } from "react";

const LeaderBoardContainer = () => {
  const {id}: any = useParams();
  const {leaderboardPageData, handleBackBtn, lang} = useDiwaliHook();
  const [heading, setHeading] = useState<string>();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if(id === '1') {
      setHeading(leaderboardPageData?.leaderboardHeadingOne)
    }else if(id === '2'){
      setHeading(leaderboardPageData?.leaderboardHeadingTwo)
    }else if(id === '3'){
      setHeading(leaderboardPageData?.leaderboardHeadingThree)
    }else if(id === '4'){
      setHeading(leaderboardPageData?.leaderboardHeadingFour)
    }else if(id === '5'){
      setHeading(leaderboardPageData?.leaderboardHeadingFive)
    }else if(id === '6'){
      setHeading(leaderboardPageData?.leaderboardHeadingSix)
    }
    // else if(id === '7'){
    //   setHeading(leaderboardPageData?.leaderboardHeadingSeven)
    // }else if(id === '8'){
    //   setHeading(leaderboardPageData?.leaderboardHeadingEight)
    // }
  },)
  
  return (
    <div className="main_container">
      <img src={leaderboardPageData?.backBtn} alt="back-btn" className="back_btn" onClick={handleBackBtn} />
      <h1 className="diwali_dhamaka_container">
        <img src={leaderboardPageData?.winnerDiwaliDhamakaImg} alt="diwali-dhamaka" className="diwali_dhamaka" />
      </h1>
      <h2 className="winner_heading"> {heading} </h2>
      <div className="winner_content">
        <img src={getAwardImg(id, lang)} alt="winner_content" className="winner_img" />
      </div>
      <TermsAndCondition src={getLeaderboardTerms(id, lang)} />
    </div>
  )
}

export default LeaderBoardContainer;